import { Link } from 'react-router-dom';

const NAVY = '#2a3d5c';
const GOLD = '#c8a750';
const STEEL = '#6e84a8';

interface BrandLogoProps {
  /** Where the logo takes you; defaults to the school picker. */
  to?: string;
  className?: string;
}

/**
 * The Jerusalem Cross Key mark and SOLA STACK wordmark, sized for the app
 * header. Mirrors app/views/shared/_brand_logo.html.erb so the app and the
 * marketing/auth pages carry the same mark.
 */
export default function BrandLogo({ to = '/app', className = '' }: BrandLogoProps) {
  return (
    <Link to={to} className={`flex items-center gap-2 no-underline ${className}`} aria-label="SolaStack home">
      <svg viewBox="0 0 120 160" className="h-8 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color: NAVY }} aria-hidden="true">
        <circle cx="60" cy="38" r="24" stroke="currentColor" strokeWidth="2.5" fill="none" opacity="0.7" />
        <rect x="58" y="24" width="4" height="28" fill="currentColor" opacity="0.55" />
        <rect x="46" y="36" width="28" height="4" fill="currentColor" opacity="0.55" />
        <rect x="54" y="23" width="12" height="3" rx="0.5" fill="currentColor" opacity="0.55" />
        <rect x="54" y="50" width="12" height="3" rx="0.5" fill="currentColor" opacity="0.55" />
        <rect x="45" y="32" width="3" height="12" rx="0.5" fill="currentColor" opacity="0.55" />
        <rect x="72" y="32" width="3" height="12" rx="0.5" fill="currentColor" opacity="0.55" />
        <line x1="51" y1="28" x2="51" y2="34" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
        <line x1="48" y1="31" x2="54" y2="31" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
        <line x1="69" y1="28" x2="69" y2="34" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
        <line x1="66" y1="31" x2="72" y2="31" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
        <line x1="51" y1="42" x2="51" y2="48" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
        <line x1="48" y1="45" x2="54" y2="45" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
        <line x1="69" y1="42" x2="69" y2="48" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
        <line x1="66" y1="45" x2="72" y2="45" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
        <rect x="57" y="62" width="6" height="72" fill="currentColor" opacity="0.5" rx="1" />
        <rect x="52" y="62" width="16" height="5" rx="1" fill="currentColor" opacity="0.6" />
        <rect x="63" y="118" width="22" height="5" rx="1" fill="currentColor" opacity="0.7" />
        <rect x="70" y="123" width="5" height="8" rx="0.5" fill="currentColor" opacity="0.6" />
        <rect x="78" y="123" width="7" height="12" rx="0.5" fill="currentColor" opacity="0.5" />
        <rect x="63" y="123" width="5" height="5" rx="0.5" fill="currentColor" opacity="0.4" />
        <rect x="63" y="130" width="12" height="4" rx="0.5" fill="currentColor" opacity="0.5" />
        <rect x="57" y="134" width="6" height="4" rx="0.5" fill="currentColor" opacity="0.6" />
      </svg>
      <span className="hidden flex-col leading-tight sm:flex">
        <span className="text-sm font-semibold uppercase tracking-[0.2em]">
          <span style={{ color: GOLD }}>Sola</span>
          <span style={{ color: STEEL }}> Stack</span>
        </span>
        <span className="text-[8px] font-medium uppercase tracking-[0.25em]" style={{ color: 'rgba(42, 61, 92, 0.5)' }}>
          Classical School Software
        </span>
      </span>
    </Link>
  );
}
